<template>
    <div class="container-fluid authorizerOrganizationWrapper">
        <div class="row">
            <div class="col-12 col-md-6 mb-4">
                <authorizer-group-info :group="group"/>
            </div>
        </div>

        <b-card no-body>
            <b-tabs card v-model="tabIndex">
                <b-tab title="利用アカウント発行状況">
                    <b-container fluid>
                        <authorizer-group-invitations
                            :timezone="timezone"
                            :group="group"
                            :can-doctor-pass="canDoctorPass">
                        </authorizer-group-invitations>
                    </b-container>
                </b-tab>
                <b-tab :title="`${$locale.patient}一覧`">
                    <b-container fluid>
                        <authorizer-group-users
                            :timezone="timezone"
                            :group="group"
                            :group-id="groupId"
                            child-group-name="法人"
                            can-tagging>
                        </authorizer-group-users>
                    </b-container>
                </b-tab>
                <b-tab title="法人一覧">
                    <b-container fluid>
                        <authorizer-child-groups
                            :timezone="timezone"
                            :group="group"
                            :child-groups-type="groupTypeCompany"
                            :can-doctor-pass="canDoctorPass"
                            can-tagging>
                        </authorizer-child-groups>
                    </b-container>
                </b-tab>
                <b-tab
                    v-if="group.is_tab_consultation"
                    :title="`${$locale.consultation_host}一覧`">
                    <b-container fluid>
                        <authorizer-group-consultations
                            :timezone="timezone"
                            :group="group"
                            :medical-courses="medicalCourses">
                        </authorizer-group-consultations>
                    </b-container>
                </b-tab>
                <b-tab
                    v-if="canDoctorPass"
                    title="ドクターパス利用一覧">
                    <b-container fluid>
                        <authorizer-group-subscriptions
                            :timezone="timezone"
                            :group="group">
                        </authorizer-group-subscriptions>
                    </b-container>
                </b-tab>
                <b-tab title="管理用タグ一覧">
                    <b-container fluid>
                        <authorizer-group-management-tags
                            :timezone="timezone"
                            :group="group">
                        </authorizer-group-management-tags>
                    </b-container>
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>

<script>
    import YokumiruHelper from '../../../YokumiruHelper'
    import constants from '../../../constants'

    export default {
        props: {
            timezone: {
                type: String,
                required: true,
            },
            group: {
                type: Object,
                required: true,
            },
            medicalCourses: {
                type: Array,
                required: true,
            },
        },

        created: function() {
            const tab = this.$route.query.tab
            this.groupId = isNaN(this.$route.query.group_id) ? null : Number(this.$route.query.group_id)

            let tabIndex = 0
            if (tab === 'group-users') {
                tabIndex = 1
            }

            setTimeout(() => {
                if (tabIndex !== 0) {
                    this.tabIndex = 1
                }
            }, 300)
        },

        computed: {
            /**
             * ドクターパスを利用可能なグループかどうか
             * @return {boolean}
             */
            canDoctorPass: function () {
                return this.group.plans.some((plan) => this.helper.isDoctorPass(plan))
            },
        },

        data: function () {
            return {
                helper: YokumiruHelper,
                groupTypeCompany: constants.groupType.company,
                tabIndex: 0,
                groupId: null,
            }
        },
    }
</script>

<style lang="scss">
.authorizerOrganizationWrapper {
    .tab-content > .tab-pane {
        overflow: hidden;
    }
}
</style>
